import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { isEmpty } from 'ramda';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOffersHistory, setPage } from '../../../actions/offersHistory';
import { selectOffersHistoryData, selectPageNumber, selectResultsOnPage } from '../../../selectors/offersHistory';
import { TThunkDispatch } from '../../../types/redux';
import { Loading } from '../../../components/OffersHistory/Desktop/commonComponents';

/**
 * Контейнер реализует подгрузку следующей страницы ленты при скролле до конца
 * Рендерит невидимый элемент, который при попадании в область видимости запускает загрузку и рендерит прелоадер
 * */
export const ShowMoreContainer: React.FC = () => {
  const [isDivHidden, setHidden] = React.useState(false);
  const dispatch = useDispatch<TThunkDispatch>();
  const { data: offersHistoryData, isFetching, isError } = useSelector(selectOffersHistoryData);
  const pageNumber = useSelector(selectPageNumber);
  const resultsOnPage = useSelector(selectResultsOnPage);

  const handleShowMoreClick = React.useCallback(async () => {
    if (!isFetching) {
      dispatch(setPage(pageNumber + 1));
      await dispatch(getOffersHistory(true));

      /**
       * После успешной загрузки div скрывается на короткий промежуток времени,
       * чтоб избежать загрузки новой страницы сразу же.
       * */
      setHidden(true);
      setTimeout(() => setHidden(false), 100);
    }
  }, [dispatch, pageNumber, isFetching]);

  const shouldHideBtn =
    isError ||
    isDivHidden ||
    !offersHistoryData ||
    isEmpty(offersHistoryData.offers) ||
    (!isFetching && pageNumber * resultsOnPage >= offersHistoryData.totalCount);

  if (shouldHideBtn) {
    return null;
  }

  return (
    <ActionAfterViewObserver
      callback={handleShowMoreClick}
      callbackDelay={0}
      percentVisible={0.1}
      triggerOnce={false}
      wrapper={false}
    >
      <div style={{ height: 30, position: 'relative' }} data-testid="offers_history_show_more">
        {isFetching && <Loading overlap size={16} />}
      </div>
    </ActionAfterViewObserver>
  );
};
